import { importAll } from "@utils/helpers";
import { ConnectorSource } from "@utils/optionsSets/OptionSets";
import { IntegrationCard } from "features";
import { MondayFormConnector } from "features/integrations/modals/MondayFormConnector";
import { SupportForm } from "features/navigation/Header/SupportForm";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { PageTemplate } from "shared/global-layouts/PageTemplate";
import { Label, SearchBar } from "shared/ui-basics/index";
import { useModal } from "use-modal-hook";
import * as Style from "./Styles";

export const IntegrationList = () => {
	const { t } = useTranslation();
	const history = useHistory();

	const connectors = useSelector((state) => state.settings.connector);
	const [searchedValue, setSearchedValue] = useState("");

	const [supportFormModal] = useModal(SupportForm);
    const [mondayFormConnector] = useModal(MondayFormConnector);
    const mondayConnectors = connectors?.filter((connector) => connector.source === ConnectorSource.Monday)

	const redirect = (id, source) => {
		history.push(`/edit-integration?id=${id}&source=${source}`);
	};
	const listIntegrations = [
		{
			variant: "primary", // displayVariant(ConnectorSource.Qualtrics),
			icon: "qualtrics.png",
			buttonName: "JS_40", // displayBtnName(ConnectorSource.Qualtrics),
			count: connectors?.filter((connector) => connector.source === ConnectorSource.Qualtrics)?.length,
			onClick: (id) => {
				redirect(id, ConnectorSource.Qualtrics);
			},
			name: "QUALTRICS",
			description: "QUALTRICS_DESCRIPTION",
			source: ConnectorSource.Qualtrics,
			classButton: "w-50",
		},
		{
			variant: "primary",
			icon: "survey-monkey.png",
			buttonName: "JS_40",
			count: connectors?.filter((connector) => connector.source === ConnectorSource.SurveyMonkey)?.length,
			onClick: (id) => {
				redirect(id, ConnectorSource.SurveyMonkey);
			},
			name: "SURVEY_MONKEY",
			description: "SURVEY_MONKEY_DESCRIPTION",
			source: ConnectorSource.SurveyMonkey,
			classButton: "w-50",
		},
		{
			variant: "primary",
			icon: "sandsiv.png",
			buttonName: "JS_40",
			count: connectors?.filter((connector) => connector.source === ConnectorSource.Sandsiv)?.length,
			onClick: (id) => {
				redirect(id, ConnectorSource.Sandsiv);
			},
			name: "SANDSIV",
			description: "SANDSIV_DESCRIPTION",
			source: ConnectorSource.Sandsiv,
			classButton: "w-50",
		},
		{
			variant: "primary",
			icon: "monday.png",
			buttonName: "JS_40",
			count: mondayConnectors?.length,
			onClick: () => {
				mondayFormConnector({ connector: connectors?.find((connector) => connector.source === ConnectorSource.Monday) });
			},
			name: "MONDAY",
			description: "MONDAY_DESCRIPTION",
            source: ConnectorSource.Monday,
            disable: mondayConnectors?.length > 0,
			classButton: "w-50",
		},
		{
			variant: "primary-outline",
			icon: "medalia.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("MEDALLIA")} ${t("INTEGRATION")}` });
			},
			name: "MEDALLIA",
			description: "MEDALLIA_DESCRIPTION",
		},

		{
			variant: "primary-outline",
			icon: "miro.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("MIRO")} ${t("INTEGRATION")}` });
			},
			name: "MIRO",
			description: "MIRO_DESCRIPTION",
		},
		{
			variant: "primary-outline",
			icon: "mural.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("MURAL")} ${t("INTEGRATION")}` });
			},
			name: "MURAL",
			description: "MURAL_DESCRIPTION",
		},

		{
			variant: "primary-outline",
			icon: "microsoft-dynamics.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("MICROSOFT_DYNAMICS")} ${t("INTEGRATION")}` });
			},
			name: "MICROSOFT_DYNAMICS",
			description: "MICROSOFT_DYNAMICS_DESCRIPTION",
		},
		{
			variant: "primary-outline",
			icon: "jira.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("JIRA")} ${t("INTEGRATION")}` });
			},
			name: "JIRA",
			description: "JIRA_DESCRIPTION",
		},
		{
			variant: "primary-outline",
			icon: "microsoft-customer-voice.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("MICROSOFT_CUSTOMER_VOICE")} ${t("INTEGRATION")}` });
			},
			name: "MICROSOFT_CUSTOMER_VOICE",
			description: "MICROSOFT_CUSTOMER_VOICE_DESCRIPTION",
		},
		{
			variant: "primary-outline",
			icon: "intercom.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("INTERCOM")} ${t("INTEGRATION")}` });
			},
			name: "INTERCOM",
			description: "INTERCOM_DESCRIPTION",
		},
		{
			variant: "primary-outline",
			icon: "mailchimp.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("MAILCHIMP")} ${t("INTEGRATION")}` });
			},
			name: "MAILCHIMP",
			description: "MAILCHIMP_DESCRIPTION",
		},
		{
			variant: "primary-outline",
			icon: "asana.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("ASANA")} ${t("INTEGRATION")}` });
			},
			name: "ASANA",
			description: "ASANA_DESCRIPTION",
		},
		{
			variant: "primary-outline",
			icon: "marketo.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("MARKETO")} ${t("INTEGRATION")}` });
			},
			name: "MARKETO",
			description: "MARKETO_DESCRIPTION",
		},

		{
			variant: "primary-outline",
			icon: "microsoft-teams.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("MICROSOFT_TEAMS")} ${t("INTEGRATION")}` });
			},
			name: "MICROSOFT_TEAMS",
			description: "MICROSOFT_TEAMS_DESCRIPTION",
		},
		{
			variant: "primary-outline",
			icon: "microsoft-power-apps.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("MICROSOFT_POWER_APPS")} ${t("INTEGRATION")}` });
			},
			name: "MICROSOFT_POWER_APPS",
			description: "MICROSOFT_POWER_APPS_DESCRIPTION",
		},
		{
			variant: "primary-outline",
			icon: "microsoft-power-bi.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("MICROSOFT_POWER_BI")} ${t("INTEGRATION")}` });
			},
			name: "MICROSOFT_POWER_BI",
			description: "MICROSOFT_POWER_BI_DESCRIPTION",
		},
		{
			variant: "primary-outline",
			icon: "salesforce.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("SALESFORCE")} ${t("INTEGRATION")}` });
			},
			name: "SALESFORCE",
			description: "SALESFORCE_DESCRIPTION",
		},
		{
			variant: "primary-outline",
			icon: "sap.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("SAP")} ${t("INTEGRATION")}` });
			},
			name: "SAP",
			description: "SAP_DESCRIPTION",
		},
		{
			variant: "primary-outline",
			icon: "service-now.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("SERVICE_NOW")} ${t("INTEGRATION")}` });
			},
			name: "SERVICE_NOW",
			description: "SERVICE_NOW_DESCRIPTION",
		},
		{
			variant: "primary-outline",
			icon: "microsoft-sharepoint.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("MICROSOFT_SHARE_POINT")} ${t("INTEGRATION")}` });
			},
			name: "MICROSOFT_SHARE_POINT",
			description: "MICROSOFT_SHARE_POINT_DESCRIPTION",
		},
		{
			variant: "primary-outline",
			icon: "slack.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("SLACK")} ${t("INTEGRATION")}` });
			},
			name: "SLACK",
			description: "SLACK_DESCRIPTION",
		},
		{
			variant: "primary-outline",
			icon: "smartsheet.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("SMART_SHEET")} ${t("INTEGRATION")}` });
			},
			name: "SMART_SHEET",
			description: "SMART_SHEET_DESCRIPTION",
		},
		{
			variant: "primary-outline",
			icon: "trello.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("TRELLO")} ${t("INTEGRATION")}` });
			},
			name: "TRELLO",
			description: "TRELLO_DESCRIPTION",
		},
		{
			variant: "primary-outline",
			icon: "zendesk.png",
			buttonName: "CONTACT_US",
			onClick: () => {
				supportFormModal({ subject: `${t("ZENDESK")} ${t("INTEGRATION")}` });
			},
			name: "ZENDESK",
			description: "ZENDESK_DESCRIPTION",
		},
	];

	const listIntegrationsConnect = listIntegrations?.filter((integration) => integration?.count > 0) || [];
	const listIntegrationsNoConnect = listIntegrations?.filter(
		(integration) => (integration.count == undefined || integration?.count === 0) && (searchedValue === "" || integration.name.toLowerCase().includes(searchedValue.toLowerCase()))
	);

	const integrations = importAll(require.context("@Assets/images/integration", false, /\.(png|jpe?g|svg)$/));

	const handleSearch = (e) => {
		const value = e.target.value;
		setSearchedValue(value);
	};
	const Search = SearchBar({ globalFilterValue: searchedValue, handleChange: handleSearch });
	return (
			<PageTemplate classNames="container ">
				{listIntegrationsConnect.length > 0 && (
					<div className="pb-5">
						<Style.WrapperBorderDiv>
							<Label fw={600} size={24} color={"#333"}>
								{t("INSTALLED_CONNECTOR")}
							</Label>
						</Style.WrapperBorderDiv>
						{listIntegrationsConnect?.map((integration, index) => (
							<IntegrationCard key={index} integration={integration} integrations={integrations} />
						))}
					</div>
				)}
				<div>
					<Label fw={600} size={24} color={"#333"}>
						{t("INSTALLED_CONNECTOR_TITLE2")}
					</Label>
					<Style.WrapperBorderDiv>
						<Style.WrapperSearch>{Search}</Style.WrapperSearch>
					</Style.WrapperBorderDiv>
					{listIntegrationsNoConnect?.map((integration, index) => (
						<IntegrationCard key={index} integration={integration} integrations={integrations} />
					))}
				</div>
			</PageTemplate>
	);
};
